module.exports = __webpack_public_path__ + "media/images/challenges/sony-talent-league-edition-ii/banner@3x-c7b3b7e6ef9a826a7639d38a384fdfc7.jpg";